
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("74kCa", function(module, exports) {
module.exports = import.meta.resolve("kzMTo");

});


const $ba8f9109d367bf16$var$playIconUrl = new URL((parcelRequire("74kCa")));
const $ba8f9109d367bf16$var$playIcon = document.getElementById("playIcon");
const $ba8f9109d367bf16$var$audioPlayer = document.getElementById("audioPlayer");
// Reciter search elements
const $ba8f9109d367bf16$var$reciterSearchInput = document.getElementById("reciterSearchInput");
const $ba8f9109d367bf16$var$reciterList = document.getElementById("reciterList");
// Narration search elements
const $ba8f9109d367bf16$var$narrationSearchInput = document.getElementById("narrationSearchInput");
const $ba8f9109d367bf16$var$narrationList = document.getElementById("narrationList");
// Surah search elements
const $ba8f9109d367bf16$var$surahSearchInput = document.getElementById("surahSearchInput");
const $ba8f9109d367bf16$var$surahList = document.getElementById("surahList");
window.currentUserSelect = {
    reciterID: "",
    narrationID: "",
    surahID: "",
    surahServer: ""
};
const $ba8f9109d367bf16$var$searchPlaceholders = {
    en: {
        reciter: "Search reciter...",
        narration: "Search narration...",
        surah: "Search surah..."
    },
    ar: {
        reciter: "\u0627\u0628\u062D\u062B \u0639\u0646 \u0642\u0627\u0631\u0626...",
        narration: "\u0627\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0645\u0635\u062D\u0641...",
        surah: "\u0627\u0628\u062D\u062B \u0639\u0646 \u0633\u0648\u0631\u0629..."
    }
};
const $ba8f9109d367bf16$var$emptyMessages = {
    en: "No results found",
    ar: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C"
};
let $ba8f9109d367bf16$var$allReciters = [];
let $ba8f9109d367bf16$var$allNarrations = [];
let $ba8f9109d367bf16$var$allSurahs = [];
let $ba8f9109d367bf16$var$surahData = null;
let $ba8f9109d367bf16$var$lang = localStorage.getItem("language") || "en";
function $ba8f9109d367bf16$var$isEmptyValue(v) {
    return v === null || v === undefined || typeof v === "string" && v.trim() === "";
}
// -- Shared keyboard navigation --
function $ba8f9109d367bf16$var$handleDropdownKeydown(e, listEl, onEnter, inputEl) {
    if (listEl.hidden) return;
    const items = listEl.querySelectorAll(".reciter-search__item:not(.reciter-search__item--empty)");
    const active = listEl.querySelector(".reciter-search__item--active");
    let idx = Array.from(items).indexOf(active);
    if (e.key === "ArrowDown") {
        e.preventDefault();
        if (active) active.classList.remove("reciter-search__item--active");
        idx = (idx + 1) % items.length;
        items[idx]?.classList.add("reciter-search__item--active");
        items[idx]?.scrollIntoView({
            block: "nearest"
        });
    } else if (e.key === "ArrowUp") {
        e.preventDefault();
        if (active) active.classList.remove("reciter-search__item--active");
        idx = (idx - 1 + items.length) % items.length;
        items[idx]?.classList.add("reciter-search__item--active");
        items[idx]?.scrollIntoView({
            block: "nearest"
        });
    } else if (e.key === "Enter") {
        e.preventDefault();
        if (active) onEnter(active);
    } else if (e.key === "Escape") {
        listEl.hidden = true;
        inputEl.blur();
    }
}
// -- Reciter search --
function $ba8f9109d367bf16$var$buildReciterList(reciters) {
    $ba8f9109d367bf16$var$reciterList.innerHTML = "";
    if (reciters.length === 0) {
        const li = document.createElement("li");
        li.className = "reciter-search__item reciter-search__item--empty";
        li.textContent = $ba8f9109d367bf16$var$emptyMessages[$ba8f9109d367bf16$var$lang] || $ba8f9109d367bf16$var$emptyMessages.en;
        $ba8f9109d367bf16$var$reciterList.appendChild(li);
        return;
    }
    const query = $ba8f9109d367bf16$var$reciterSearchInput.value.trim();
    reciters.forEach((reciter)=>{
        const li = document.createElement("li");
        li.className = "reciter-search__item";
        if (query) {
            const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");
            li.innerHTML = reciter.name.replace(regex, `<mark class="reciter-search__highlight">$1</mark>`);
        } else li.textContent = reciter.name;
        li.dataset.id = reciter.id;
        li.dataset.name = reciter.name;
        li.addEventListener("mousedown", (e)=>{
            e.preventDefault();
            $ba8f9109d367bf16$var$selectReciter(reciter);
        });
        $ba8f9109d367bf16$var$reciterList.appendChild(li);
    });
}
function $ba8f9109d367bf16$var$showReciterList(reciters) {
    $ba8f9109d367bf16$var$buildReciterList(reciters);
    $ba8f9109d367bf16$var$reciterList.hidden = false;
}
function $ba8f9109d367bf16$var$hideReciterList() {
    $ba8f9109d367bf16$var$reciterList.hidden = true;
}
function $ba8f9109d367bf16$var$selectReciter(reciter) {
    $ba8f9109d367bf16$var$reciterSearchInput.value = reciter.name;
    $ba8f9109d367bf16$var$reciterSearchInput.dataset.selectedId = reciter.id;
    $ba8f9109d367bf16$var$hideReciterList();
    currentUserSelect.reciterID = reciter.id;
    $ba8f9109d367bf16$var$onReciterSelected(reciter.id);
    if ($ba8f9109d367bf16$var$allNarrations.length !== 1) setTimeout(()=>$ba8f9109d367bf16$var$narrationSearchInput.focus(), 50);
}
const $ba8f9109d367bf16$var$resetReciterSearch = (clearInput = true)=>{
    if (clearInput) {
        $ba8f9109d367bf16$var$reciterSearchInput.value = "";
        $ba8f9109d367bf16$var$reciterSearchInput.dataset.selectedId = "";
    }
    $ba8f9109d367bf16$var$hideReciterList();
};
$ba8f9109d367bf16$var$reciterSearchInput.addEventListener("input", ()=>{
    $ba8f9109d367bf16$var$reciterSearchInput.dataset.selectedId = "";
    const query = $ba8f9109d367bf16$var$reciterSearchInput.value.trim().toLowerCase();
    const filtered = query ? $ba8f9109d367bf16$var$allReciters.filter((r)=>r.name.toLowerCase().includes(query)) : $ba8f9109d367bf16$var$allReciters;
    $ba8f9109d367bf16$var$showReciterList(filtered);
});
$ba8f9109d367bf16$var$reciterSearchInput.addEventListener("focus", ()=>{
    const query = $ba8f9109d367bf16$var$reciterSearchInput.value.trim().toLowerCase();
    const filtered = query ? $ba8f9109d367bf16$var$allReciters.filter((r)=>r.name.toLowerCase().includes(query)) : $ba8f9109d367bf16$var$allReciters;
    $ba8f9109d367bf16$var$showReciterList(filtered);
});
$ba8f9109d367bf16$var$reciterSearchInput.addEventListener("blur", ()=>setTimeout($ba8f9109d367bf16$var$hideReciterList, 160));
$ba8f9109d367bf16$var$reciterSearchInput.addEventListener("keydown", (e)=>$ba8f9109d367bf16$var$handleDropdownKeydown(e, $ba8f9109d367bf16$var$reciterList, (active)=>{
        $ba8f9109d367bf16$var$selectReciter({
            id: active.dataset.id,
            name: active.dataset.name
        });
    }, $ba8f9109d367bf16$var$reciterSearchInput));
// -- Narration search --
function $ba8f9109d367bf16$var$buildNarrationList(narrations) {
    $ba8f9109d367bf16$var$narrationList.innerHTML = "";
    if (narrations.length === 0) {
        const li = document.createElement("li");
        li.className = "reciter-search__item reciter-search__item--empty";
        li.textContent = $ba8f9109d367bf16$var$emptyMessages[$ba8f9109d367bf16$var$lang] || $ba8f9109d367bf16$var$emptyMessages.en;
        $ba8f9109d367bf16$var$narrationList.appendChild(li);
        return;
    }
    const query = $ba8f9109d367bf16$var$narrationSearchInput.value.trim();
    narrations.forEach((narration)=>{
        const li = document.createElement("li");
        li.className = "reciter-search__item";
        if (query) {
            const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");
            li.innerHTML = narration.name.replace(regex, `<mark class="reciter-search__highlight">$1</mark>`);
        } else li.textContent = narration.name;
        li.dataset.id = narration.id;
        li.dataset.name = narration.name;
        li.dataset.server = narration.server;
        li.dataset.surahlist = narration.surahList;
        li.addEventListener("mousedown", (e)=>{
            e.preventDefault();
            $ba8f9109d367bf16$var$selectNarration(narration);
        });
        $ba8f9109d367bf16$var$narrationList.appendChild(li);
    });
}
function $ba8f9109d367bf16$var$showNarrationList(narrations) {
    $ba8f9109d367bf16$var$buildNarrationList(narrations);
    $ba8f9109d367bf16$var$narrationList.hidden = false;
}
function $ba8f9109d367bf16$var$hideNarrationList() {
    $ba8f9109d367bf16$var$narrationList.hidden = true;
}
function $ba8f9109d367bf16$var$selectNarration(narration) {
    $ba8f9109d367bf16$var$narrationSearchInput.value = narration.name;
    $ba8f9109d367bf16$var$narrationSearchInput.dataset.selectedId = narration.id;
    $ba8f9109d367bf16$var$hideNarrationList();
    currentUserSelect.narrationID = narration.id;
    $ba8f9109d367bf16$var$onNarrationSelected(narration);
    setTimeout(()=>$ba8f9109d367bf16$var$surahSearchInput.focus(), 50);
}
const $ba8f9109d367bf16$var$resetNarrationSearch = (clearInput = true)=>{
    if (clearInput) {
        $ba8f9109d367bf16$var$narrationSearchInput.value = "";
        $ba8f9109d367bf16$var$narrationSearchInput.dataset.selectedId = "";
    }
    $ba8f9109d367bf16$var$hideNarrationList();
    $ba8f9109d367bf16$var$allNarrations = [];
};
$ba8f9109d367bf16$var$narrationSearchInput.addEventListener("input", ()=>{
    $ba8f9109d367bf16$var$narrationSearchInput.dataset.selectedId = "";
    const query = $ba8f9109d367bf16$var$narrationSearchInput.value.trim().toLowerCase();
    const filtered = query ? $ba8f9109d367bf16$var$allNarrations.filter((n)=>n.name.toLowerCase().includes(query)) : $ba8f9109d367bf16$var$allNarrations;
    $ba8f9109d367bf16$var$showNarrationList(filtered);
});
$ba8f9109d367bf16$var$narrationSearchInput.addEventListener("focus", ()=>{
    const query = $ba8f9109d367bf16$var$narrationSearchInput.value.trim().toLowerCase();
    const filtered = query ? $ba8f9109d367bf16$var$allNarrations.filter((n)=>n.name.toLowerCase().includes(query)) : $ba8f9109d367bf16$var$allNarrations;
    $ba8f9109d367bf16$var$showNarrationList(filtered);
});
$ba8f9109d367bf16$var$narrationSearchInput.addEventListener("blur", ()=>setTimeout($ba8f9109d367bf16$var$hideNarrationList, 160));
$ba8f9109d367bf16$var$narrationSearchInput.addEventListener("keydown", (e)=>$ba8f9109d367bf16$var$handleDropdownKeydown(e, $ba8f9109d367bf16$var$narrationList, (active)=>{
        $ba8f9109d367bf16$var$selectNarration({
            id: active.dataset.id,
            name: active.dataset.name,
            server: active.dataset.server,
            surahList: active.dataset.surahlist
        });
    }, $ba8f9109d367bf16$var$narrationSearchInput));
// -- Surah search --
function $ba8f9109d367bf16$var$buildSurahList(surahs) {
    $ba8f9109d367bf16$var$surahList.innerHTML = "";
    if (surahs.length === 0) {
        const li = document.createElement("li");
        li.className = "reciter-search__item reciter-search__item--empty";
        li.textContent = $ba8f9109d367bf16$var$emptyMessages[$ba8f9109d367bf16$var$lang] || $ba8f9109d367bf16$var$emptyMessages.en;
        $ba8f9109d367bf16$var$surahList.appendChild(li);
        return;
    }
    const query = $ba8f9109d367bf16$var$surahSearchInput.value.trim();
    surahs.forEach((surah)=>{
        const li = document.createElement("li");
        li.className = "reciter-search__item";
        if (query) {
            const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");
            li.innerHTML = surah.name.replace(regex, `<mark class="reciter-search__highlight">$1</mark>`);
        } else li.textContent = surah.name;
        li.dataset.value = surah.value;
        li.dataset.id = surah.id;
        li.dataset.name = surah.name;
        li.addEventListener("mousedown", (e)=>{
            e.preventDefault();
            $ba8f9109d367bf16$var$selectSurah(surah);
        });
        $ba8f9109d367bf16$var$surahList.appendChild(li);
    });
}
function $ba8f9109d367bf16$var$showSurahList(surahs) {
    $ba8f9109d367bf16$var$buildSurahList(surahs);
    $ba8f9109d367bf16$var$surahList.hidden = false;
}
function $ba8f9109d367bf16$var$hideSurahList() {
    $ba8f9109d367bf16$var$surahList.hidden = true;
}
function $ba8f9109d367bf16$var$selectSurah(surah, autoPlay = true) {
    $ba8f9109d367bf16$var$surahSearchInput.value = surah.name;
    $ba8f9109d367bf16$var$surahSearchInput.dataset.selectedValue = surah.value;
    $ba8f9109d367bf16$var$hideSurahList();
    $ba8f9109d367bf16$var$audioPlayer.pause();
    $ba8f9109d367bf16$var$audioPlayer.src = surah.value;
    $ba8f9109d367bf16$var$audioPlayer.load();
    if (autoPlay) $ba8f9109d367bf16$var$audioPlayer.addEventListener("canplay", ()=>$ba8f9109d367bf16$var$audioPlayer.play(), {
        once: true
    });
    currentUserSelect.surahServer = surah.value;
    currentUserSelect.surahID = surah.id;
    localStorage.setItem("quranSelections", JSON.stringify(currentUserSelect));
    window.dispatchEvent(new CustomEvent("surahListUpdated"));
}
// Expose selectSurah for player.js
window.selectSurah = $ba8f9109d367bf16$var$selectSurah;
const $ba8f9109d367bf16$var$resetSurahSearch = (clearInput = true)=>{
    if (clearInput) {
        $ba8f9109d367bf16$var$surahSearchInput.value = "";
        $ba8f9109d367bf16$var$surahSearchInput.dataset.selectedValue = "";
    }
    $ba8f9109d367bf16$var$hideSurahList();
    $ba8f9109d367bf16$var$allSurahs = [];
    window.allSurahs = $ba8f9109d367bf16$var$allSurahs;
};
$ba8f9109d367bf16$var$surahSearchInput.addEventListener("input", ()=>{
    $ba8f9109d367bf16$var$surahSearchInput.dataset.selectedValue = "";
    const query = $ba8f9109d367bf16$var$surahSearchInput.value.trim().toLowerCase();
    const filtered = query ? $ba8f9109d367bf16$var$allSurahs.filter((s)=>s.name.toLowerCase().includes(query)) : $ba8f9109d367bf16$var$allSurahs;
    $ba8f9109d367bf16$var$showSurahList(filtered);
});
$ba8f9109d367bf16$var$surahSearchInput.addEventListener("focus", ()=>{
    const query = $ba8f9109d367bf16$var$surahSearchInput.value.trim().toLowerCase();
    const filtered = query ? $ba8f9109d367bf16$var$allSurahs.filter((s)=>s.name.toLowerCase().includes(query)) : $ba8f9109d367bf16$var$allSurahs;
    $ba8f9109d367bf16$var$showSurahList(filtered);
});
$ba8f9109d367bf16$var$surahSearchInput.addEventListener("blur", ()=>setTimeout($ba8f9109d367bf16$var$hideSurahList, 160));
$ba8f9109d367bf16$var$surahSearchInput.addEventListener("keydown", (e)=>$ba8f9109d367bf16$var$handleDropdownKeydown(e, $ba8f9109d367bf16$var$surahList, (active)=>{
        $ba8f9109d367bf16$var$selectSurah({
            value: active.dataset.value,
            id: active.dataset.id,
            name: active.dataset.name
        });
    }, $ba8f9109d367bf16$var$surahSearchInput));
// Close all dropdowns when clicking outside
document.addEventListener("click", (e)=>{
    if (!e.target.closest("#reciterSearchWrapper")) $ba8f9109d367bf16$var$hideReciterList();
    if (!e.target.closest("#narrationSearchWrapper")) $ba8f9109d367bf16$var$hideNarrationList();
    if (!e.target.closest("#surahSearchWrapper")) $ba8f9109d367bf16$var$hideSurahList();
});
// -- API calls --
async function $ba8f9109d367bf16$var$fetchSurahNames() {
    try {
        const res = await fetch(`https://mp3quran.net/api/v3/suwar?language=${$ba8f9109d367bf16$var$lang}`);
        return await res.json();
    } catch (error) {
        console.error("Error fetching surah names:", error);
        return null;
    }
}
async function $ba8f9109d367bf16$var$fetchReciters() {
    try {
        const res = await fetch(`https://www.mp3quran.net/api/v3/reciters?language=${$ba8f9109d367bf16$var$lang}`);
        const data = await res.json();
        $ba8f9109d367bf16$var$allReciters = data.reciters;
    } catch (error) {
        console.error("Error fetching reciters:", error);
    }
}
// -- Reciter selected: populate narration list --
function $ba8f9109d367bf16$var$onReciterSelected(reciterId) {
    if (!reciterId) {
        $ba8f9109d367bf16$var$resetNarrationSearch(true);
        $ba8f9109d367bf16$var$resetSurahSearch(true);
        return;
    }
    const selectedReciter = $ba8f9109d367bf16$var$allReciters.find((r)=>r.id == reciterId);
    if (!selectedReciter) return;
    // rest drop downs
    $ba8f9109d367bf16$var$resetNarrationSearch(true);
    $ba8f9109d367bf16$var$resetSurahSearch(true);
    // then Build narration list from reciter's moshaf array
    $ba8f9109d367bf16$var$allNarrations = selectedReciter.moshaf.map((m)=>({
            id: String(m.id),
            name: m.name,
            server: m.server,
            surahList: m.surah_list
        }));
    // Auto-select if only one narration available
    if ($ba8f9109d367bf16$var$allNarrations.length === 1) $ba8f9109d367bf16$var$selectNarration($ba8f9109d367bf16$var$allNarrations[0]);
}
// -- Narration selected: rebuild surah list --
function $ba8f9109d367bf16$var$onNarrationSelected(narration) {
    $ba8f9109d367bf16$var$resetSurahSearch(true);
    if (!$ba8f9109d367bf16$var$surahData?.suwar) {
        console.error("Surah data not loaded");
        return;
    }
    const surahIds = narration.surahList.split(",");
    const reciterName = $ba8f9109d367bf16$var$reciterSearchInput.value;
    // Build surah list for the chosen narration
    $ba8f9109d367bf16$var$allSurahs = [];
    surahIds.forEach((surahId)=>{
        $ba8f9109d367bf16$var$surahData.suwar.forEach((surahName)=>{
            if (surahName.id == surahId) {
                const paddedId = String(surahName.id).padStart(3, "0");
                $ba8f9109d367bf16$var$allSurahs.push({
                    value: `${narration.server}${paddedId}.mp3`,
                    id: String(surahName.id),
                    name: surahName.name,
                    reciter: reciterName
                });
            }
        });
    });
    // Sync with player.js
    window.allSurahs = $ba8f9109d367bf16$var$allSurahs;
    window.dispatchEvent(new CustomEvent("surahListUpdated"));
}
// -- Init --
async function $ba8f9109d367bf16$var$initializeData() {
    $ba8f9109d367bf16$var$lang = localStorage.getItem("language") || "en";
    const p = $ba8f9109d367bf16$var$searchPlaceholders[$ba8f9109d367bf16$var$lang] || $ba8f9109d367bf16$var$searchPlaceholders.en;
    $ba8f9109d367bf16$var$reciterSearchInput.placeholder = p.reciter;
    $ba8f9109d367bf16$var$narrationSearchInput.placeholder = p.narration;
    $ba8f9109d367bf16$var$surahSearchInput.placeholder = p.surah;
    $ba8f9109d367bf16$var$resetReciterSearch(true);
    $ba8f9109d367bf16$var$resetNarrationSearch(true);
    $ba8f9109d367bf16$var$resetSurahSearch(true);
    $ba8f9109d367bf16$var$surahData = await $ba8f9109d367bf16$var$fetchSurahNames();
    await $ba8f9109d367bf16$var$fetchReciters();
    // Restore last user selection if available
    const saved = localStorage.getItem("quranSelections");
    if (saved) {
        Object.assign(currentUserSelect, JSON.parse(saved));
        await $ba8f9109d367bf16$var$loadPrevSelect();
    }
}
async function $ba8f9109d367bf16$var$loadPrevSelect() {
    if (!currentUserSelect.reciterID) return;
    const reciter = $ba8f9109d367bf16$var$allReciters.find((r)=>String(r.id) === String(currentUserSelect.reciterID));
    if (!reciter) return;
    $ba8f9109d367bf16$var$reciterSearchInput.value = reciter.name;
    $ba8f9109d367bf16$var$reciterSearchInput.dataset.selectedId = reciter.id;
    $ba8f9109d367bf16$var$allNarrations = reciter.moshaf.map((m)=>({
            id: String(m.id),
            name: m.name,
            server: m.server,
            surahList: m.surah_list
        }));
    const savedNarration = $ba8f9109d367bf16$var$allNarrations.find((n)=>n.id === String(currentUserSelect.narrationID));
    if (!savedNarration) return;
    $ba8f9109d367bf16$var$narrationSearchInput.value = savedNarration.name;
    $ba8f9109d367bf16$var$narrationSearchInput.dataset.selectedId = savedNarration.id;
    const surahIds = savedNarration.surahList.split(",");
    $ba8f9109d367bf16$var$allSurahs = [];
    surahIds.forEach((surahId)=>{
        $ba8f9109d367bf16$var$surahData.suwar.forEach((surahName)=>{
            if (surahName.id == surahId) {
                const paddedId = String(surahName.id).padStart(3, "0");
                $ba8f9109d367bf16$var$allSurahs.push({
                    value: `${savedNarration.server}${paddedId}.mp3`,
                    id: String(surahName.id),
                    name: surahName.name,
                    reciter: reciter.name
                });
            }
        });
    });
    window.allSurahs = $ba8f9109d367bf16$var$allSurahs;
    const savedSurah = $ba8f9109d367bf16$var$allSurahs.find((s)=>s.value === currentUserSelect.surahServer);
    if (savedSurah) // autoPlay = false — just restore state silently
    $ba8f9109d367bf16$var$selectSurah(savedSurah, false);
    window.dispatchEvent(new CustomEvent("surahListUpdated"));
}
// Language change: re-init
async function $ba8f9109d367bf16$var$onLanguageChange(event) {
    $ba8f9109d367bf16$var$lang = event.detail.lang;
    const p = $ba8f9109d367bf16$var$searchPlaceholders[$ba8f9109d367bf16$var$lang] || $ba8f9109d367bf16$var$searchPlaceholders.en;
    $ba8f9109d367bf16$var$reciterSearchInput.placeholder = p.reciter;
    $ba8f9109d367bf16$var$narrationSearchInput.placeholder = p.narration;
    $ba8f9109d367bf16$var$surahSearchInput.placeholder = p.surah;
    if ($ba8f9109d367bf16$var$audioPlayer) {
        $ba8f9109d367bf16$var$audioPlayer.pause();
        $ba8f9109d367bf16$var$playIcon.src = $ba8f9109d367bf16$var$playIconUrl.href;
    }
    await $ba8f9109d367bf16$var$initializeData();
}
// -- Event listeners --
window.addEventListener("languageChanged", $ba8f9109d367bf16$var$onLanguageChange);
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $ba8f9109d367bf16$var$initializeData);
else $ba8f9109d367bf16$var$initializeData();
 //test if it changes


//# sourceMappingURL=repo.bd720c07.js.map
